/* tslint:disable */
/* eslint-disable */
/**
 * Pecosta Reporting API
 * Data pro reporty nad ClickHouse
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AuctionedItemsOrganizationResponse
 */
export interface AuctionedItemsOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsOrganizationResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsOrganizationResponse
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @interface AuctionedItemsPeriodResponse
 */
export interface AuctionedItemsPeriodResponse {
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsPeriodResponse
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsPeriodResponse
     */
    'auctioned': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsPeriodResponse
     */
    'stockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsPeriodResponse
     */
    'ratioPercent'?: number | null;
    /**
     * 
     * @type {Array<AuctionedItemsRowResponse>}
     * @memberof AuctionedItemsPeriodResponse
     */
    'rows': Array<AuctionedItemsRowResponse>;
}
/**
 * 
 * @export
 * @interface AuctionedItemsResponse
 */
export interface AuctionedItemsResponse {
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsResponse
     */
    'periodFrom': string;
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsResponse
     */
    'periodTo': string;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsResponse
     */
    'totalAuctioned': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsResponse
     */
    'totalStockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsResponse
     */
    'totalRatioPercent'?: number | null;
    /**
     * 
     * @type {Array<AuctionedItemsOrganizationResponse>}
     * @memberof AuctionedItemsResponse
     */
    'organizations': Array<AuctionedItemsOrganizationResponse>;
    /**
     * 
     * @type {Array<AuctionedItemsPeriodResponse>}
     * @memberof AuctionedItemsResponse
     */
    'periods': Array<AuctionedItemsPeriodResponse>;
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface AuctionedItemsRowResponse
 */
export interface AuctionedItemsRowResponse {
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsRowResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof AuctionedItemsRowResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsRowResponse
     */
    'auctioned': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsRowResponse
     */
    'stockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsRowResponse
     */
    'ratioPercent'?: number | null;
}
/**
 * 
 * @export
 * @interface CheckReport
 */
export interface CheckReport {
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'service': string;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'version'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'environment'?: string | null;
    /**
     * 
     * @type {CheckStatus}
     * @memberof CheckReport
     */
    'status': CheckStatus;
    /**
     * 
     * @type {string}
     * @memberof CheckReport
     */
    'checkedAt': string;
    /**
     * 
     * @type {boolean}
     * @memberof CheckReport
     */
    'cached'?: boolean;
    /**
     * 
     * @type {Array<CheckResult>}
     * @memberof CheckReport
     */
    'checks': Array<CheckResult>;
}


/**
 * 
 * @export
 * @interface CheckResult
 */
export interface CheckResult {
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'target'?: string | null;
    /**
     * 
     * @type {CheckStatus}
     * @memberof CheckResult
     */
    'status': CheckStatus;
    /**
     * 
     * @type {number}
     * @memberof CheckResult
     */
    'latencyMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckResult
     */
    'detail'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const CheckStatus = {
    Ok: 'OK',
    Fail: 'FAIL',
    Skipped: 'SKIPPED'
} as const;

export type CheckStatus = typeof CheckStatus[keyof typeof CheckStatus];


/**
 * 
 * @export
 * @interface DeleteOrderItemsRequest
 */
export interface DeleteOrderItemsRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof DeleteOrderItemsRequest
     */
    'orderIds': Array<number>;
}
/**
 * 
 * @export
 * @interface DeleteOrderItemsResponse
 */
export interface DeleteOrderItemsResponse {
    /**
     * 
     * @type {number}
     * @memberof DeleteOrderItemsResponse
     */
    'deletedOrders'?: number;
}
/**
 * 
 * @export
 * @interface IngestOrderItemRequest
 */
export interface IngestOrderItemRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderSentDate': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderSentAt': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderCreatedDate'?: string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'deliveryDate'?: string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'orderId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'orderItemId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'orderNumber': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'parentCompanyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'userId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'portalId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'companyName': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'companyShortname': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'productId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'priceType': string;
    /**
     * 
     * @type {boolean}
     * @memberof IngestOrderItemRequest
     */
    'isGaranted'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'priceUnit': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'purchasePrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'basicPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'packageItemPrice': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'vatRate': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'lineNet': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'lineGross': number;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedAuctionPrice'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedVariantId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minGuaranteedSupplierId'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minPriceVd'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minPriceVdAuction'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'minPriceVdSupplierId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IngestOrderItemRequest
     */
    'minPriceVdSupplierName': string;
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemRequest
     */
    'comparePrice'?: number | null;
}
/**
 * 
 * @export
 * @interface IngestOrderItemsRequest
 */
export interface IngestOrderItemsRequest {
    /**
     * 
     * @type {Array<IngestOrderItemRequest>}
     * @memberof IngestOrderItemsRequest
     */
    'items': Array<IngestOrderItemRequest>;
}
/**
 * 
 * @export
 * @interface IngestOrderItemsResponse
 */
export interface IngestOrderItemsResponse {
    /**
     * 
     * @type {number}
     * @memberof IngestOrderItemsResponse
     */
    'insertedRows'?: number;
}
/**
 * 
 * @export
 * @interface IngestStockReceiptRequest
 */
export interface IngestStockReceiptRequest {
    /**
     * 
     * @type {string}
     * @memberof IngestStockReceiptRequest
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof IngestStockReceiptRequest
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof IngestStockReceiptRequest
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof IngestStockReceiptRequest
     */
    'enteredBy': string;
    /**
     * 
     * @type {string}
     * @memberof IngestStockReceiptRequest
     */
    'enteredAt': string;
}
/**
 * 
 * @export
 * @interface MyReportResponse
 */
export interface MyReportResponse {
    /**
     * 
     * @type {string}
     * @memberof MyReportResponse
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof MyReportResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof MyReportResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MyReportResponse
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceDayResponse
 */
export interface PriceEvidenceDayResponse {
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceDayResponse
     */
    'date': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceDayResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceDayResponse
     */
    'minVolume': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceItemResponse
 */
export interface PriceEvidenceItemResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'orderItemId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'sentDate': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'priceDate': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'companyId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'portalId'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'priceVariantId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'userName': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'productName': string;
    /**
     * 
     * @type {boolean}
     * @memberof PriceEvidenceItemResponse
     */
    'isGaranted'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'auctionPrice': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'minAuctionPrice'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceItemResponse
     */
    'minSupplierName'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceItemsResponse
 */
export interface PriceEvidenceItemsResponse {
    /**
     * 
     * @type {Array<PriceEvidenceItemResponse>}
     * @memberof PriceEvidenceItemsResponse
     */
    'items': Array<PriceEvidenceItemResponse>;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemsResponse
     */
    'page'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemsResponse
     */
    'size'?: number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceItemsResponse
     */
    'totalCount'?: number;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceItemsResponse
     */
    'total': PriceEvidenceTotalResponse;
}
/**
 * 
 * @export
 * @interface PriceEvidenceOrderResponse
 */
export interface PriceEvidenceOrderResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrderResponse
     */
    'orderId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceOrderResponse
     */
    'orderNumber': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceOrderResponse
     */
    'sentDate': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceOrderResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceOrderResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrderResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrderResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrderResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceOrganizationResponse
 */
export interface PriceEvidenceOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrganizationResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceOrganizationResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrganizationResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrganizationResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceOrganizationResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceProductResponse
 */
export interface PriceEvidenceProductResponse {
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceProductResponse
     */
    'productEcid': string;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceProductResponse
     */
    'productName': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceProductResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceProductResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceProductResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceResponse
 */
export interface PriceEvidenceResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceEvidenceResponse
     */
    'periods': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PriceEvidenceResponse
     */
    'availablePeriods': Array<string>;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceResponse
     */
    'totalVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceResponse
     */
    'auctionedVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceResponse
     */
    'winningVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceResponse
     */
    'totalMinVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceResponse
     */
    'totalDifference': number;
    /**
     * 
     * @type {Array<PriceEvidenceSupplierResponse>}
     * @memberof PriceEvidenceResponse
     */
    'suppliers': Array<PriceEvidenceSupplierResponse>;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceResponse
     */
    'suppliersTotal': PriceEvidenceTotalResponse;
    /**
     * 
     * @type {Array<PriceEvidenceOrganizationResponse>}
     * @memberof PriceEvidenceResponse
     */
    'organizations': Array<PriceEvidenceOrganizationResponse>;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceResponse
     */
    'organizationsTotal': PriceEvidenceTotalResponse;
    /**
     * 
     * @type {Array<PriceEvidenceUserResponse>}
     * @memberof PriceEvidenceResponse
     */
    'users': Array<PriceEvidenceUserResponse>;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceResponse
     */
    'usersTotal': PriceEvidenceTotalResponse;
    /**
     * 
     * @type {Array<PriceEvidenceOrderResponse>}
     * @memberof PriceEvidenceResponse
     */
    'orders': Array<PriceEvidenceOrderResponse>;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceResponse
     */
    'ordersTotal': PriceEvidenceTotalResponse;
    /**
     * 
     * @type {Array<PriceEvidenceProductResponse>}
     * @memberof PriceEvidenceResponse
     */
    'products': Array<PriceEvidenceProductResponse>;
    /**
     * 
     * @type {PriceEvidenceTotalResponse}
     * @memberof PriceEvidenceResponse
     */
    'productsTotal': PriceEvidenceTotalResponse;
    /**
     * 
     * @type {Array<PriceEvidenceDayResponse>}
     * @memberof PriceEvidenceResponse
     */
    'days': Array<PriceEvidenceDayResponse>;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface PriceEvidenceSupplierResponse
 */
export interface PriceEvidenceSupplierResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceSupplierResponse
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceSupplierResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceSupplierResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceSupplierResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceSupplierResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceTotalResponse
 */
export interface PriceEvidenceTotalResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceTotalResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceTotalResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceTotalResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PriceEvidenceUserResponse
 */
export interface PriceEvidenceUserResponse {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceUserResponse
     */
    'userId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceUserResponse
     */
    'userName': string;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceUserResponse
     */
    'volume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceUserResponse
     */
    'minVolume': number;
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceUserResponse
     */
    'difference': number;
}
/**
 * 
 * @export
 * @interface PurchaseBreakdownResponse
 */
export interface PurchaseBreakdownResponse {
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseBreakdownResponse
     */
    'periods': Array<string>;
    /**
     * 
     * @type {Array<PurchaseBreakdownRowResponse>}
     * @memberof PurchaseBreakdownResponse
     */
    'byOrganization': Array<PurchaseBreakdownRowResponse>;
    /**
     * 
     * @type {Array<PurchaseBreakdownRowResponse>}
     * @memberof PurchaseBreakdownResponse
     */
    'bySupplier': Array<PurchaseBreakdownRowResponse>;
    /**
     * 
     * @type {Array<PurchaseBreakdownRowResponse>}
     * @memberof PurchaseBreakdownResponse
     */
    'byCategory': Array<PurchaseBreakdownRowResponse>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PurchaseBreakdownResponse
     */
    'periodTotals': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownResponse
     */
    'total': number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseBreakdownResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface PurchaseBreakdownRowResponse
 */
export interface PurchaseBreakdownRowResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseBreakdownRowResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseBreakdownRowResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<number>}
     * @memberof PurchaseBreakdownRowResponse
     */
    'values': Array<number>;
    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownRowResponse
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PurchaseOverviewOrganizationResponse
 */
export interface PurchaseOverviewOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewOrganizationResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewOrganizationResponse
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @interface PurchaseOverviewPeriodResponse
 */
export interface PurchaseOverviewPeriodResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewPeriodResponse
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewPeriodResponse
     */
    'purchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewPeriodResponse
     */
    'stockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewPeriodResponse
     */
    'ratioPercent'?: number | null;
    /**
     * 
     * @type {Array<PurchaseOverviewRowResponse>}
     * @memberof PurchaseOverviewPeriodResponse
     */
    'rows': Array<PurchaseOverviewRowResponse>;
}
/**
 * 
 * @export
 * @interface PurchaseOverviewResponse
 */
export interface PurchaseOverviewResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewResponse
     */
    'periodFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewResponse
     */
    'periodTo': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewResponse
     */
    'totalPurchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewResponse
     */
    'totalStockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewResponse
     */
    'totalRatioPercent'?: number | null;
    /**
     * 
     * @type {Array<PurchaseOverviewOrganizationResponse>}
     * @memberof PurchaseOverviewResponse
     */
    'organizations': Array<PurchaseOverviewOrganizationResponse>;
    /**
     * 
     * @type {Array<PurchaseOverviewPeriodResponse>}
     * @memberof PurchaseOverviewResponse
     */
    'periods': Array<PurchaseOverviewPeriodResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof PurchaseOverviewResponse
     */
    'demo'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface PurchaseOverviewRowResponse
 */
export interface PurchaseOverviewRowResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewRowResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseOverviewRowResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewRowResponse
     */
    'purchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewRowResponse
     */
    'stockReceipt': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewRowResponse
     */
    'ratioPercent'?: number | null;
}
/**
 * 
 * @export
 * @interface PurchaseSavingsCategoryResponse
 */
export interface PurchaseSavingsCategoryResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'categoryEcid': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'categoryName': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'purchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'auctioned': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'saving': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsCategoryResponse
     */
    'savingPercent'?: number | null;
}
/**
 * 
 * @export
 * @interface PurchaseSavingsOptionResponse
 */
export interface PurchaseSavingsOptionResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsOptionResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsOptionResponse
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface PurchaseSavingsOrganizationResponse
 */
export interface PurchaseSavingsOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'purchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'auctioned': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'saving': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'savingPercent'?: number | null;
    /**
     * 
     * @type {Array<PurchaseSavingsCategoryResponse>}
     * @memberof PurchaseSavingsOrganizationResponse
     */
    'rows': Array<PurchaseSavingsCategoryResponse>;
}
/**
 * 
 * @export
 * @interface PurchaseSavingsResponse
 */
export interface PurchaseSavingsResponse {
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsResponse
     */
    'periodFrom': string;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsResponse
     */
    'periodTo': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsResponse
     */
    'totalPurchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsResponse
     */
    'totalAuctioned': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsResponse
     */
    'totalSaving': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsResponse
     */
    'totalSavingPercent'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof PurchaseSavingsResponse
     */
    'availablePeriods': Array<string>;
    /**
     * 
     * @type {Array<PurchaseSavingsOptionResponse>}
     * @memberof PurchaseSavingsResponse
     */
    'availableOrganizations': Array<PurchaseSavingsOptionResponse>;
    /**
     * 
     * @type {Array<PurchaseSavingsOptionResponse>}
     * @memberof PurchaseSavingsResponse
     */
    'availableCategories': Array<PurchaseSavingsOptionResponse>;
    /**
     * 
     * @type {Array<PurchaseSavingsOrganizationResponse>}
     * @memberof PurchaseSavingsResponse
     */
    'organizations': Array<PurchaseSavingsOrganizationResponse>;
    /**
     * 
     * @type {Array<PurchaseSavingsSupplierResponse>}
     * @memberof PurchaseSavingsResponse
     */
    'suppliers': Array<PurchaseSavingsSupplierResponse>;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface PurchaseSavingsSupplierResponse
 */
export interface PurchaseSavingsSupplierResponse {
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsSupplierResponse
     */
    'supplierId'?: number;
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsSupplierResponse
     */
    'supplierName': string;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsSupplierResponse
     */
    'purchase': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsSupplierResponse
     */
    'saving': number;
    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsSupplierResponse
     */
    'savingPercent'?: number | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ReportCode = {
    EventsDailySummary: 'EVENTS_DAILY_SUMMARY',
    PurchasesByCategory: 'PURCHASES_BY_CATEGORY',
    OverpaidItems: 'OVERPAID_ITEMS',
    PurchasesByBuyer: 'PURCHASES_BY_BUYER',
    PurchaseSummary: 'PURCHASE_SUMMARY'
} as const;

export type ReportCode = typeof ReportCode[keyof typeof ReportCode];


/**
 * 
 * @export
 * @interface ReportColumnResponse
 */
export interface ReportColumnResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportColumnResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ReportColumnResponse
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ReportDefinitionResponse
 */
export interface ReportDefinitionResponse {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportDefinitionResponse
     */
    'code': ReportCode;
    /**
     * 
     * @type {string}
     * @memberof ReportDefinitionResponse
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ReportDefinitionResponse
     */
    'description': string;
    /**
     * 
     * @type {Array<ReportParamResponse>}
     * @memberof ReportDefinitionResponse
     */
    'params': Array<ReportParamResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof ReportDefinitionResponse
     */
    'supportsGroupBy'?: boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportGroupBy = {
    Company: 'COMPANY',
    User: 'USER'
} as const;

export type ReportGroupBy = typeof ReportGroupBy[keyof typeof ReportGroupBy];


/**
 * 
 * @export
 * @interface ReportParamResponse
 */
export interface ReportParamResponse {
    /**
     * 
     * @type {string}
     * @memberof ReportParamResponse
     */
    'name': string;
    /**
     * 
     * @type {ReportParamType}
     * @memberof ReportParamResponse
     */
    'type': ReportParamType;
    /**
     * 
     * @type {boolean}
     * @memberof ReportParamResponse
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ReportParamResponse
     */
    'description': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ReportParamType = {
    String: 'STRING',
    Long: 'LONG',
    Decimal: 'DECIMAL',
    Boolean: 'BOOLEAN',
    Date: 'DATE',
    DateTime: 'DATE_TIME'
} as const;

export type ReportParamType = typeof ReportParamType[keyof typeof ReportParamType];


/**
 * 
 * @export
 * @interface ReportRunRequest
 */
export interface ReportRunRequest {
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ReportRunRequest
     */
    'params': { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof ReportRunRequest
     */
    'maxRows'?: number | null;
    /**
     * 
     * @type {ReportGroupBy}
     * @memberof ReportRunRequest
     */
    'groupBy'?: ReportGroupBy | null;
}


/**
 * 
 * @export
 * @interface ReportRunResponse
 */
export interface ReportRunResponse {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportRunResponse
     */
    'code': ReportCode;
    /**
     * 
     * @type {Array<ReportColumnResponse>}
     * @memberof ReportRunResponse
     */
    'columns': Array<ReportColumnResponse>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof ReportRunResponse
     */
    'rows': Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof ReportRunResponse
     */
    'rowCount'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ReportRunResponse
     */
    'truncated'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ReportRunResponse
     */
    'durationMs'?: number;
    /**
     * 
     * @type {string}
     * @memberof ReportRunResponse
     */
    'generatedAt': string;
}


/**
 * 
 * @export
 * @interface WinningItemsOrganizationResponse
 */
export interface WinningItemsOrganizationResponse {
    /**
     * 
     * @type {number}
     * @memberof WinningItemsOrganizationResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WinningItemsOrganizationResponse
     */
    'organizationName': string;
}
/**
 * 
 * @export
 * @interface WinningItemsPeriodResponse
 */
export interface WinningItemsPeriodResponse {
    /**
     * 
     * @type {string}
     * @memberof WinningItemsPeriodResponse
     */
    'period': string;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsPeriodResponse
     */
    'comparable': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsPeriodResponse
     */
    'winning': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsPeriodResponse
     */
    'ratioPercent'?: number | null;
    /**
     * 
     * @type {Array<WinningItemsRowResponse>}
     * @memberof WinningItemsPeriodResponse
     */
    'rows': Array<WinningItemsRowResponse>;
}
/**
 * 
 * @export
 * @interface WinningItemsResponse
 */
export interface WinningItemsResponse {
    /**
     * 
     * @type {string}
     * @memberof WinningItemsResponse
     */
    'periodFrom': string;
    /**
     * 
     * @type {string}
     * @memberof WinningItemsResponse
     */
    'periodTo': string;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsResponse
     */
    'totalComparable': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsResponse
     */
    'totalWinning': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsResponse
     */
    'totalRatioPercent'?: number | null;
    /**
     * 
     * @type {Array<WinningItemsOrganizationResponse>}
     * @memberof WinningItemsResponse
     */
    'organizations': Array<WinningItemsOrganizationResponse>;
    /**
     * 
     * @type {Array<WinningItemsPeriodResponse>}
     * @memberof WinningItemsResponse
     */
    'periods': Array<WinningItemsPeriodResponse>;
    /**
     * 
     * @type {string}
     * @memberof WinningItemsResponse
     */
    'generatedAt': string;
}
/**
 * 
 * @export
 * @interface WinningItemsRowResponse
 */
export interface WinningItemsRowResponse {
    /**
     * 
     * @type {number}
     * @memberof WinningItemsRowResponse
     */
    'organizationId'?: number;
    /**
     * 
     * @type {string}
     * @memberof WinningItemsRowResponse
     */
    'organizationName': string;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsRowResponse
     */
    'comparable': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsRowResponse
     */
    'winning': number;
    /**
     * 
     * @type {number}
     * @memberof WinningItemsRowResponse
     */
    'ratioPercent'?: number | null;
}

/**
 * AuctionedItemsApi - axios parameter creator
 * @export
 */
export const AuctionedItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Podíl vysoutěžených položek za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuctionedItemsGet: async (months?: number | null, organizationId?: number, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/auctioned-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuctionedItemsApi - functional programming interface
 * @export
 */
export const AuctionedItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuctionedItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Podíl vysoutěžených položek za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiAuctionedItemsGet(months?: number | null, organizationId?: number, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AuctionedItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiAuctionedItemsGet(months, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuctionedItemsApi.apiAuctionedItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuctionedItemsApi - factory interface
 * @export
 */
export const AuctionedItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuctionedItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Podíl vysoutěžených položek za posledních N měsíců
         * @param {AuctionedItemsApiApiAuctionedItemsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiAuctionedItemsGet(requestParameters: AuctionedItemsApiApiAuctionedItemsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<AuctionedItemsResponse> {
            return localVarFp.apiAuctionedItemsGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuctionedItemsApi - interface
 * @export
 * @interface AuctionedItemsApi
 */
export interface AuctionedItemsApiInterface {
    /**
     * 
     * @summary Podíl vysoutěžených položek za posledních N měsíců
     * @param {AuctionedItemsApiApiAuctionedItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionedItemsApiInterface
     */
    apiAuctionedItemsGet(requestParameters?: AuctionedItemsApiApiAuctionedItemsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<AuctionedItemsResponse>;

}

/**
 * Request parameters for apiAuctionedItemsGet operation in AuctionedItemsApi.
 * @export
 * @interface AuctionedItemsApiApiAuctionedItemsGetRequest
 */
export interface AuctionedItemsApiApiAuctionedItemsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsApiApiAuctionedItemsGet
     */
    readonly months?: number | null

    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsApiApiAuctionedItemsGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof AuctionedItemsApiApiAuctionedItemsGet
     */
    readonly portalId?: number
}

/**
 * AuctionedItemsApi - object-oriented interface
 * @export
 * @class AuctionedItemsApi
 * @extends {BaseAPI}
 */
export class AuctionedItemsApi extends BaseAPI implements AuctionedItemsApiInterface {
    /**
     * 
     * @summary Podíl vysoutěžených položek za posledních N měsíců
     * @param {AuctionedItemsApiApiAuctionedItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuctionedItemsApi
     */
    public apiAuctionedItemsGet(requestParameters: AuctionedItemsApiApiAuctionedItemsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return AuctionedItemsApiFp(this.configuration).apiAuctionedItemsGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CheckResourceApi - axios parameter creator
 * @export
 */
export const CheckResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check
         * @param {string | null} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGet: async (only?: string | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (only !== undefined) {
                localVarQueryParameter['only'] = only;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CheckResourceApi - functional programming interface
 * @export
 */
export const CheckResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CheckResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check
         * @param {string | null} [only] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkGet(only?: string | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CheckReport>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkGet(only, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CheckResourceApi.checkGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CheckResourceApi - factory interface
 * @export
 */
export const CheckResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CheckResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary Check
         * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkGet(requestParameters: CheckResourceApiCheckGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport> {
            return localVarFp.checkGet(requestParameters.only, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CheckResourceApi - interface
 * @export
 * @interface CheckResourceApi
 */
export interface CheckResourceApiInterface {
    /**
     * 
     * @summary Check
     * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckResourceApiInterface
     */
    checkGet(requestParameters?: CheckResourceApiCheckGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<CheckReport>;

}

/**
 * Request parameters for checkGet operation in CheckResourceApi.
 * @export
 * @interface CheckResourceApiCheckGetRequest
 */
export interface CheckResourceApiCheckGetRequest {
    /**
     * 
     * @type {string}
     * @memberof CheckResourceApiCheckGet
     */
    readonly only?: string | null
}

/**
 * CheckResourceApi - object-oriented interface
 * @export
 * @class CheckResourceApi
 * @extends {BaseAPI}
 */
export class CheckResourceApi extends BaseAPI implements CheckResourceApiInterface {
    /**
     * 
     * @summary Check
     * @param {CheckResourceApiCheckGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CheckResourceApi
     */
    public checkGet(requestParameters: CheckResourceApiCheckGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CheckResourceApiFp(this.configuration).checkGet(requestParameters.only, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InfoResourceApi - axios parameter creator
 * @export
 */
export const InfoResourceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/info`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InfoResourceApi - functional programming interface
 * @export
 */
export const InfoResourceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InfoResourceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async infoGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.infoGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InfoResourceApi.infoGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InfoResourceApi - factory interface
 * @export
 */
export const InfoResourceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InfoResourceApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Build Info
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.infoGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InfoResourceApi - interface
 * @export
 * @interface InfoResourceApi
 */
export interface InfoResourceApiInterface {
    /**
     * 
     * @summary Get Build Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApiInterface
     */
    infoGet(options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

}

/**
 * InfoResourceApi - object-oriented interface
 * @export
 * @class InfoResourceApi
 * @extends {BaseAPI}
 */
export class InfoResourceApi extends BaseAPI implements InfoResourceApiInterface {
    /**
     * 
     * @summary Get Build Info
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InfoResourceApi
     */
    public infoGet(options?: RawAxiosRequestConfig) {
        return InfoResourceApiFp(this.configuration).infoGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * IngestApi - axios parameter creator
 * @export
 */
export const IngestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Smaze z faktu radky danych objednavek (napr. po stornu)
         * @param {DeleteOrderItemsRequest} deleteOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsDeletePost: async (deleteOrderItemsRequest: DeleteOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deleteOrderItemsRequest' is not null or undefined
            assertParamExists('apiIngestOrderItemsDeletePost', 'deleteOrderItemsRequest', deleteOrderItemsRequest)
            const localVarPath = `/api/ingest/order-items/delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deleteOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestOrderItemsRequest} ingestOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsPost: async (ingestOrderItemsRequest: IngestOrderItemsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestOrderItemsRequest' is not null or undefined
            assertParamExists('apiIngestOrderItemsPost', 'ingestOrderItemsRequest', ingestOrderItemsRequest)
            const localVarPath = `/api/ingest/order-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestOrderItemsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Vyprazdni order_items_fact pred kompletnim prelevanim historie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsResetPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ingest/order-items/reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestPingGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ingest/ping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Zapise prijemky (prijem na sklad) za provozovnu a mesic
         * @param {Array<IngestStockReceiptRequest>} ingestStockReceiptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestStockReceiptsPost: async (ingestStockReceiptRequest: Array<IngestStockReceiptRequest>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'ingestStockReceiptRequest' is not null or undefined
            assertParamExists('apiIngestStockReceiptsPost', 'ingestStockReceiptRequest', ingestStockReceiptRequest)
            const localVarPath = `/api/ingest/stock-receipts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(ingestStockReceiptRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IngestApi - functional programming interface
 * @export
 */
export const IngestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IngestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Smaze z faktu radky danych objednavek (napr. po stornu)
         * @param {DeleteOrderItemsRequest} deleteOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestOrderItemsDeletePost(deleteOrderItemsRequest: DeleteOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteOrderItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestOrderItemsDeletePost(deleteOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestOrderItemsDeletePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestOrderItemsRequest} ingestOrderItemsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestOrderItemsPost(ingestOrderItemsRequest: IngestOrderItemsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IngestOrderItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestOrderItemsPost(ingestOrderItemsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestOrderItemsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Vyprazdni order_items_fact pred kompletnim prelevanim historie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestOrderItemsResetPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestOrderItemsResetPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestOrderItemsResetPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestPingGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestPingGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestPingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Zapise prijemky (prijem na sklad) za provozovnu a mesic
         * @param {Array<IngestStockReceiptRequest>} ingestStockReceiptRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiIngestStockReceiptsPost(ingestStockReceiptRequest: Array<IngestStockReceiptRequest>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiIngestStockReceiptsPost(ingestStockReceiptRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IngestApi.apiIngestStockReceiptsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IngestApi - factory interface
 * @export
 */
export const IngestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IngestApiFp(configuration)
    return {
        /**
         * 
         * @summary Smaze z faktu radky danych objednavek (napr. po stornu)
         * @param {IngestApiApiIngestOrderItemsDeletePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsDeletePost(requestParameters: IngestApiApiIngestOrderItemsDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOrderItemsResponse> {
            return localVarFp.apiIngestOrderItemsDeletePost(requestParameters.deleteOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zapise davku polozek odeslane objednavky do order_items_fact
         * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestOrderItemsResponse> {
            return localVarFp.apiIngestOrderItemsPost(requestParameters.ingestOrderItemsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Vyprazdni order_items_fact pred kompletnim prelevanim historie
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestOrderItemsResetPost(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIngestOrderItemsResetPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Overi ingest token volajiciho (204 = zapis povolen)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestPingGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiIngestPingGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Zapise prijemky (prijem na sklad) za provozovnu a mesic
         * @param {IngestApiApiIngestStockReceiptsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiIngestStockReceiptsPost(requestParameters: IngestApiApiIngestStockReceiptsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.apiIngestStockReceiptsPost(requestParameters.ingestStockReceiptRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IngestApi - interface
 * @export
 * @interface IngestApi
 */
export interface IngestApiInterface {
    /**
     * 
     * @summary Smaze z faktu radky danych objednavek (napr. po stornu)
     * @param {IngestApiApiIngestOrderItemsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestOrderItemsDeletePost(requestParameters: IngestApiApiIngestOrderItemsDeletePostRequest, options?: RawAxiosRequestConfig): AxiosPromise<DeleteOrderItemsResponse>;

    /**
     * 
     * @summary Zapise davku polozek odeslane objednavky do order_items_fact
     * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<IngestOrderItemsResponse>;

    /**
     * 
     * @summary Vyprazdni order_items_fact pred kompletnim prelevanim historie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestOrderItemsResetPost(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Overi ingest token volajiciho (204 = zapis povolen)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestPingGet(options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Zapise prijemky (prijem na sklad) za provozovnu a mesic
     * @param {IngestApiApiIngestStockReceiptsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApiInterface
     */
    apiIngestStockReceiptsPost(requestParameters: IngestApiApiIngestStockReceiptsPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<number>;

}

/**
 * Request parameters for apiIngestOrderItemsDeletePost operation in IngestApi.
 * @export
 * @interface IngestApiApiIngestOrderItemsDeletePostRequest
 */
export interface IngestApiApiIngestOrderItemsDeletePostRequest {
    /**
     * 
     * @type {DeleteOrderItemsRequest}
     * @memberof IngestApiApiIngestOrderItemsDeletePost
     */
    readonly deleteOrderItemsRequest: DeleteOrderItemsRequest
}

/**
 * Request parameters for apiIngestOrderItemsPost operation in IngestApi.
 * @export
 * @interface IngestApiApiIngestOrderItemsPostRequest
 */
export interface IngestApiApiIngestOrderItemsPostRequest {
    /**
     * 
     * @type {IngestOrderItemsRequest}
     * @memberof IngestApiApiIngestOrderItemsPost
     */
    readonly ingestOrderItemsRequest: IngestOrderItemsRequest
}

/**
 * Request parameters for apiIngestStockReceiptsPost operation in IngestApi.
 * @export
 * @interface IngestApiApiIngestStockReceiptsPostRequest
 */
export interface IngestApiApiIngestStockReceiptsPostRequest {
    /**
     * 
     * @type {Array<IngestStockReceiptRequest>}
     * @memberof IngestApiApiIngestStockReceiptsPost
     */
    readonly ingestStockReceiptRequest: Array<IngestStockReceiptRequest>
}

/**
 * IngestApi - object-oriented interface
 * @export
 * @class IngestApi
 * @extends {BaseAPI}
 */
export class IngestApi extends BaseAPI implements IngestApiInterface {
    /**
     * 
     * @summary Smaze z faktu radky danych objednavek (napr. po stornu)
     * @param {IngestApiApiIngestOrderItemsDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestOrderItemsDeletePost(requestParameters: IngestApiApiIngestOrderItemsDeletePostRequest, options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestOrderItemsDeletePost(requestParameters.deleteOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zapise davku polozek odeslane objednavky do order_items_fact
     * @param {IngestApiApiIngestOrderItemsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestOrderItemsPost(requestParameters: IngestApiApiIngestOrderItemsPostRequest, options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestOrderItemsPost(requestParameters.ingestOrderItemsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Vyprazdni order_items_fact pred kompletnim prelevanim historie
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestOrderItemsResetPost(options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestOrderItemsResetPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Overi ingest token volajiciho (204 = zapis povolen)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestPingGet(options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestPingGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Zapise prijemky (prijem na sklad) za provozovnu a mesic
     * @param {IngestApiApiIngestStockReceiptsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IngestApi
     */
    public apiIngestStockReceiptsPost(requestParameters: IngestApiApiIngestStockReceiptsPostRequest, options?: RawAxiosRequestConfig) {
        return IngestApiFp(this.configuration).apiIngestStockReceiptsPost(requestParameters.ingestStockReceiptRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MyReportsApi - axios parameter creator
 * @export
 */
export const MyReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Reporty dostupné v této organizaci a na tomto portálu
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMyReportsGet: async (organizationId?: number, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/my-reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MyReportsApi - functional programming interface
 * @export
 */
export const MyReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MyReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Reporty dostupné v této organizaci a na tomto portálu
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiMyReportsGet(organizationId?: number, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MyReportResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiMyReportsGet(organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MyReportsApi.apiMyReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MyReportsApi - factory interface
 * @export
 */
export const MyReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MyReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Reporty dostupné v této organizaci a na tomto portálu
         * @param {MyReportsApiApiMyReportsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiMyReportsGet(requestParameters: MyReportsApiApiMyReportsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<MyReportResponse>> {
            return localVarFp.apiMyReportsGet(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MyReportsApi - interface
 * @export
 * @interface MyReportsApi
 */
export interface MyReportsApiInterface {
    /**
     * 
     * @summary Reporty dostupné v této organizaci a na tomto portálu
     * @param {MyReportsApiApiMyReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyReportsApiInterface
     */
    apiMyReportsGet(requestParameters?: MyReportsApiApiMyReportsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<MyReportResponse>>;

}

/**
 * Request parameters for apiMyReportsGet operation in MyReportsApi.
 * @export
 * @interface MyReportsApiApiMyReportsGetRequest
 */
export interface MyReportsApiApiMyReportsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof MyReportsApiApiMyReportsGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof MyReportsApiApiMyReportsGet
     */
    readonly portalId?: number
}

/**
 * MyReportsApi - object-oriented interface
 * @export
 * @class MyReportsApi
 * @extends {BaseAPI}
 */
export class MyReportsApi extends BaseAPI implements MyReportsApiInterface {
    /**
     * 
     * @summary Reporty dostupné v této organizaci a na tomto portálu
     * @param {MyReportsApiApiMyReportsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MyReportsApi
     */
    public apiMyReportsGet(requestParameters: MyReportsApiApiMyReportsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return MyReportsApiFp(this.configuration).apiMyReportsGet(requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PriceEvidenceApi - axios parameter creator
 * @export
 */
export const PriceEvidenceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Evidence cen za vybraná období
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [orderId] 
         * @param {number} [organizationId] 
         * @param {Array<string> | null} [periods] 
         * @param {number} [portalId] 
         * @param {string | null} [productEcid] 
         * @param {number | null} [supplierId] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPriceEvidenceGet: async (filterOrganizationId?: number | null, orderId?: number | null, organizationId?: number, periods?: Array<string> | null, portalId?: number, productEcid?: string | null, supplierId?: number | null, userId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/price-evidence`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterOrganizationId !== undefined) {
                localVarQueryParameter['filterOrganizationId'] = filterOrganizationId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (periods) {
                localVarQueryParameter['periods'] = periods;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (productEcid !== undefined) {
                localVarQueryParameter['productEcid'] = productEcid;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Položky evidence cen po stránkách
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [orderId] 
         * @param {number} [organizationId] 
         * @param {number | null} [page] 
         * @param {Array<string> | null} [periods] 
         * @param {number} [portalId] 
         * @param {string | null} [productEcid] 
         * @param {number | null} [size] 
         * @param {number | null} [supplierId] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPriceEvidenceItemsGet: async (filterOrganizationId?: number | null, orderId?: number | null, organizationId?: number, page?: number | null, periods?: Array<string> | null, portalId?: number, productEcid?: string | null, size?: number | null, supplierId?: number | null, userId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/price-evidence/items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filterOrganizationId !== undefined) {
                localVarQueryParameter['filterOrganizationId'] = filterOrganizationId;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (periods) {
                localVarQueryParameter['periods'] = periods;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (productEcid !== undefined) {
                localVarQueryParameter['productEcid'] = productEcid;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PriceEvidenceApi - functional programming interface
 * @export
 */
export const PriceEvidenceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PriceEvidenceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Evidence cen za vybraná období
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [orderId] 
         * @param {number} [organizationId] 
         * @param {Array<string> | null} [periods] 
         * @param {number} [portalId] 
         * @param {string | null} [productEcid] 
         * @param {number | null} [supplierId] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPriceEvidenceGet(filterOrganizationId?: number | null, orderId?: number | null, organizationId?: number, periods?: Array<string> | null, portalId?: number, productEcid?: string | null, supplierId?: number | null, userId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceEvidenceResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPriceEvidenceGet(filterOrganizationId, orderId, organizationId, periods, portalId, productEcid, supplierId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceEvidenceApi.apiPriceEvidenceGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Položky evidence cen po stránkách
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [orderId] 
         * @param {number} [organizationId] 
         * @param {number | null} [page] 
         * @param {Array<string> | null} [periods] 
         * @param {number} [portalId] 
         * @param {string | null} [productEcid] 
         * @param {number | null} [size] 
         * @param {number | null} [supplierId] 
         * @param {number | null} [userId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPriceEvidenceItemsGet(filterOrganizationId?: number | null, orderId?: number | null, organizationId?: number, page?: number | null, periods?: Array<string> | null, portalId?: number, productEcid?: string | null, size?: number | null, supplierId?: number | null, userId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceEvidenceItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPriceEvidenceItemsGet(filterOrganizationId, orderId, organizationId, page, periods, portalId, productEcid, size, supplierId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PriceEvidenceApi.apiPriceEvidenceItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PriceEvidenceApi - factory interface
 * @export
 */
export const PriceEvidenceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PriceEvidenceApiFp(configuration)
    return {
        /**
         * 
         * @summary Evidence cen za vybraná období
         * @param {PriceEvidenceApiApiPriceEvidenceGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPriceEvidenceGet(requestParameters: PriceEvidenceApiApiPriceEvidenceGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PriceEvidenceResponse> {
            return localVarFp.apiPriceEvidenceGet(requestParameters.filterOrganizationId, requestParameters.orderId, requestParameters.organizationId, requestParameters.periods, requestParameters.portalId, requestParameters.productEcid, requestParameters.supplierId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Položky evidence cen po stránkách
         * @param {PriceEvidenceApiApiPriceEvidenceItemsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPriceEvidenceItemsGet(requestParameters: PriceEvidenceApiApiPriceEvidenceItemsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PriceEvidenceItemsResponse> {
            return localVarFp.apiPriceEvidenceItemsGet(requestParameters.filterOrganizationId, requestParameters.orderId, requestParameters.organizationId, requestParameters.page, requestParameters.periods, requestParameters.portalId, requestParameters.productEcid, requestParameters.size, requestParameters.supplierId, requestParameters.userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PriceEvidenceApi - interface
 * @export
 * @interface PriceEvidenceApi
 */
export interface PriceEvidenceApiInterface {
    /**
     * 
     * @summary Evidence cen za vybraná období
     * @param {PriceEvidenceApiApiPriceEvidenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceEvidenceApiInterface
     */
    apiPriceEvidenceGet(requestParameters?: PriceEvidenceApiApiPriceEvidenceGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PriceEvidenceResponse>;

    /**
     * 
     * @summary Položky evidence cen po stránkách
     * @param {PriceEvidenceApiApiPriceEvidenceItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceEvidenceApiInterface
     */
    apiPriceEvidenceItemsGet(requestParameters?: PriceEvidenceApiApiPriceEvidenceItemsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PriceEvidenceItemsResponse>;

}

/**
 * Request parameters for apiPriceEvidenceGet operation in PriceEvidenceApi.
 * @export
 * @interface PriceEvidenceApiApiPriceEvidenceGetRequest
 */
export interface PriceEvidenceApiApiPriceEvidenceGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly filterOrganizationId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly orderId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {Array<string>}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly periods?: Array<string> | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly portalId?: number

    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly productEcid?: string | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly supplierId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceGet
     */
    readonly userId?: number | null
}

/**
 * Request parameters for apiPriceEvidenceItemsGet operation in PriceEvidenceApi.
 * @export
 * @interface PriceEvidenceApiApiPriceEvidenceItemsGetRequest
 */
export interface PriceEvidenceApiApiPriceEvidenceItemsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly filterOrganizationId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly orderId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly page?: number | null

    /**
     * 
     * @type {Array<string>}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly periods?: Array<string> | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly portalId?: number

    /**
     * 
     * @type {string}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly productEcid?: string | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly size?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly supplierId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PriceEvidenceApiApiPriceEvidenceItemsGet
     */
    readonly userId?: number | null
}

/**
 * PriceEvidenceApi - object-oriented interface
 * @export
 * @class PriceEvidenceApi
 * @extends {BaseAPI}
 */
export class PriceEvidenceApi extends BaseAPI implements PriceEvidenceApiInterface {
    /**
     * 
     * @summary Evidence cen za vybraná období
     * @param {PriceEvidenceApiApiPriceEvidenceGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceEvidenceApi
     */
    public apiPriceEvidenceGet(requestParameters: PriceEvidenceApiApiPriceEvidenceGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PriceEvidenceApiFp(this.configuration).apiPriceEvidenceGet(requestParameters.filterOrganizationId, requestParameters.orderId, requestParameters.organizationId, requestParameters.periods, requestParameters.portalId, requestParameters.productEcid, requestParameters.supplierId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Položky evidence cen po stránkách
     * @param {PriceEvidenceApiApiPriceEvidenceItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PriceEvidenceApi
     */
    public apiPriceEvidenceItemsGet(requestParameters: PriceEvidenceApiApiPriceEvidenceItemsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PriceEvidenceApiFp(this.configuration).apiPriceEvidenceItemsGet(requestParameters.filterOrganizationId, requestParameters.orderId, requestParameters.organizationId, requestParameters.page, requestParameters.periods, requestParameters.portalId, requestParameters.productEcid, requestParameters.size, requestParameters.supplierId, requestParameters.userId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseBreakdownApi - axios parameter creator
 * @export
 */
export const PurchaseBreakdownApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Nákupy po měsících ve třech pohledech
         * @param {string | null} [categoryEcid] 
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {number | null} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseBreakdownGet: async (categoryEcid?: string | null, filterOrganizationId?: number | null, months?: number | null, organizationId?: number, portalId?: number, supplierId?: number | null, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/purchase-breakdown`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (filterOrganizationId !== undefined) {
                localVarQueryParameter['filterOrganizationId'] = filterOrganizationId;
            }

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }

            if (supplierId !== undefined) {
                localVarQueryParameter['supplierId'] = supplierId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseBreakdownApi - functional programming interface
 * @export
 */
export const PurchaseBreakdownApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseBreakdownApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Nákupy po měsících ve třech pohledech
         * @param {string | null} [categoryEcid] 
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {number | null} [supplierId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPurchaseBreakdownGet(categoryEcid?: string | null, filterOrganizationId?: number | null, months?: number | null, organizationId?: number, portalId?: number, supplierId?: number | null, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseBreakdownResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPurchaseBreakdownGet(categoryEcid, filterOrganizationId, months, organizationId, portalId, supplierId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseBreakdownApi.apiPurchaseBreakdownGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseBreakdownApi - factory interface
 * @export
 */
export const PurchaseBreakdownApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseBreakdownApiFp(configuration)
    return {
        /**
         * 
         * @summary Nákupy po měsících ve třech pohledech
         * @param {PurchaseBreakdownApiApiPurchaseBreakdownGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseBreakdownGet(requestParameters: PurchaseBreakdownApiApiPurchaseBreakdownGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseBreakdownResponse> {
            return localVarFp.apiPurchaseBreakdownGet(requestParameters.categoryEcid, requestParameters.filterOrganizationId, requestParameters.months, requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseBreakdownApi - interface
 * @export
 * @interface PurchaseBreakdownApi
 */
export interface PurchaseBreakdownApiInterface {
    /**
     * 
     * @summary Nákupy po měsících ve třech pohledech
     * @param {PurchaseBreakdownApiApiPurchaseBreakdownGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseBreakdownApiInterface
     */
    apiPurchaseBreakdownGet(requestParameters?: PurchaseBreakdownApiApiPurchaseBreakdownGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseBreakdownResponse>;

}

/**
 * Request parameters for apiPurchaseBreakdownGet operation in PurchaseBreakdownApi.
 * @export
 * @interface PurchaseBreakdownApiApiPurchaseBreakdownGetRequest
 */
export interface PurchaseBreakdownApiApiPurchaseBreakdownGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly categoryEcid?: string | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly filterOrganizationId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly months?: number | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly portalId?: number

    /**
     * 
     * @type {number}
     * @memberof PurchaseBreakdownApiApiPurchaseBreakdownGet
     */
    readonly supplierId?: number | null
}

/**
 * PurchaseBreakdownApi - object-oriented interface
 * @export
 * @class PurchaseBreakdownApi
 * @extends {BaseAPI}
 */
export class PurchaseBreakdownApi extends BaseAPI implements PurchaseBreakdownApiInterface {
    /**
     * 
     * @summary Nákupy po měsících ve třech pohledech
     * @param {PurchaseBreakdownApiApiPurchaseBreakdownGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseBreakdownApi
     */
    public apiPurchaseBreakdownGet(requestParameters: PurchaseBreakdownApiApiPurchaseBreakdownGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PurchaseBreakdownApiFp(this.configuration).apiPurchaseBreakdownGet(requestParameters.categoryEcid, requestParameters.filterOrganizationId, requestParameters.months, requestParameters.organizationId, requestParameters.portalId, requestParameters.supplierId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseOverviewApi - axios parameter creator
 * @export
 */
export const PurchaseOverviewApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Celková evidence nákupu za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseOverviewGet: async (months?: number | null, organizationId?: number, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/purchase-overview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseOverviewApi - functional programming interface
 * @export
 */
export const PurchaseOverviewApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseOverviewApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Celková evidence nákupu za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPurchaseOverviewGet(months?: number | null, organizationId?: number, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseOverviewResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPurchaseOverviewGet(months, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseOverviewApi.apiPurchaseOverviewGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseOverviewApi - factory interface
 * @export
 */
export const PurchaseOverviewApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseOverviewApiFp(configuration)
    return {
        /**
         * 
         * @summary Celková evidence nákupu za posledních N měsíců
         * @param {PurchaseOverviewApiApiPurchaseOverviewGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseOverviewGet(requestParameters: PurchaseOverviewApiApiPurchaseOverviewGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseOverviewResponse> {
            return localVarFp.apiPurchaseOverviewGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseOverviewApi - interface
 * @export
 * @interface PurchaseOverviewApi
 */
export interface PurchaseOverviewApiInterface {
    /**
     * 
     * @summary Celková evidence nákupu za posledních N měsíců
     * @param {PurchaseOverviewApiApiPurchaseOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOverviewApiInterface
     */
    apiPurchaseOverviewGet(requestParameters?: PurchaseOverviewApiApiPurchaseOverviewGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseOverviewResponse>;

}

/**
 * Request parameters for apiPurchaseOverviewGet operation in PurchaseOverviewApi.
 * @export
 * @interface PurchaseOverviewApiApiPurchaseOverviewGetRequest
 */
export interface PurchaseOverviewApiApiPurchaseOverviewGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewApiApiPurchaseOverviewGet
     */
    readonly months?: number | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewApiApiPurchaseOverviewGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof PurchaseOverviewApiApiPurchaseOverviewGet
     */
    readonly portalId?: number
}

/**
 * PurchaseOverviewApi - object-oriented interface
 * @export
 * @class PurchaseOverviewApi
 * @extends {BaseAPI}
 */
export class PurchaseOverviewApi extends BaseAPI implements PurchaseOverviewApiInterface {
    /**
     * 
     * @summary Celková evidence nákupu za posledních N měsíců
     * @param {PurchaseOverviewApiApiPurchaseOverviewGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseOverviewApi
     */
    public apiPurchaseOverviewGet(requestParameters: PurchaseOverviewApiApiPurchaseOverviewGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PurchaseOverviewApiFp(this.configuration).apiPurchaseOverviewGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PurchaseSavingsApi - axios parameter creator
 * @export
 */
export const PurchaseSavingsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Úspory nákupu za posledních N měsíců
         * @param {string | null} [categoryEcid] 
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {string | null} [period] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseSavingsGet: async (categoryEcid?: string | null, filterOrganizationId?: number | null, months?: number | null, organizationId?: number, period?: string | null, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/purchase-savings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryEcid !== undefined) {
                localVarQueryParameter['categoryEcid'] = categoryEcid;
            }

            if (filterOrganizationId !== undefined) {
                localVarQueryParameter['filterOrganizationId'] = filterOrganizationId;
            }

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (period !== undefined) {
                localVarQueryParameter['period'] = period;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PurchaseSavingsApi - functional programming interface
 * @export
 */
export const PurchaseSavingsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PurchaseSavingsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Úspory nákupu za posledních N měsíců
         * @param {string | null} [categoryEcid] 
         * @param {number | null} [filterOrganizationId] 
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {string | null} [period] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPurchaseSavingsGet(categoryEcid?: string | null, filterOrganizationId?: number | null, months?: number | null, organizationId?: number, period?: string | null, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PurchaseSavingsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPurchaseSavingsGet(categoryEcid, filterOrganizationId, months, organizationId, period, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PurchaseSavingsApi.apiPurchaseSavingsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PurchaseSavingsApi - factory interface
 * @export
 */
export const PurchaseSavingsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PurchaseSavingsApiFp(configuration)
    return {
        /**
         * 
         * @summary Úspory nákupu za posledních N měsíců
         * @param {PurchaseSavingsApiApiPurchaseSavingsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPurchaseSavingsGet(requestParameters: PurchaseSavingsApiApiPurchaseSavingsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseSavingsResponse> {
            return localVarFp.apiPurchaseSavingsGet(requestParameters.categoryEcid, requestParameters.filterOrganizationId, requestParameters.months, requestParameters.organizationId, requestParameters.period, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PurchaseSavingsApi - interface
 * @export
 * @interface PurchaseSavingsApi
 */
export interface PurchaseSavingsApiInterface {
    /**
     * 
     * @summary Úspory nákupu za posledních N měsíců
     * @param {PurchaseSavingsApiApiPurchaseSavingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseSavingsApiInterface
     */
    apiPurchaseSavingsGet(requestParameters?: PurchaseSavingsApiApiPurchaseSavingsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<PurchaseSavingsResponse>;

}

/**
 * Request parameters for apiPurchaseSavingsGet operation in PurchaseSavingsApi.
 * @export
 * @interface PurchaseSavingsApiApiPurchaseSavingsGetRequest
 */
export interface PurchaseSavingsApiApiPurchaseSavingsGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly categoryEcid?: string | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly filterOrganizationId?: number | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly months?: number | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {string}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly period?: string | null

    /**
     * 
     * @type {number}
     * @memberof PurchaseSavingsApiApiPurchaseSavingsGet
     */
    readonly portalId?: number
}

/**
 * PurchaseSavingsApi - object-oriented interface
 * @export
 * @class PurchaseSavingsApi
 * @extends {BaseAPI}
 */
export class PurchaseSavingsApi extends BaseAPI implements PurchaseSavingsApiInterface {
    /**
     * 
     * @summary Úspory nákupu za posledních N měsíců
     * @param {PurchaseSavingsApiApiPurchaseSavingsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PurchaseSavingsApi
     */
    public apiPurchaseSavingsGet(requestParameters: PurchaseSavingsApiApiPurchaseSavingsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return PurchaseSavingsApiFp(this.configuration).apiPurchaseSavingsGet(requestParameters.categoryEcid, requestParameters.filterOrganizationId, requestParameters.months, requestParameters.organizationId, requestParameters.period, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportsApi - axios parameter creator
 * @export
 */
export const ReportsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportCode} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeGet: async (code: ReportCode, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiReportsCodeGet', 'code', code)
            const localVarPath = `/api/reports/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportCode} code 
         * @param {ReportRunRequest} reportRunRequest 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeRunPost: async (code: ReportCode, reportRunRequest: ReportRunRequest, organizationId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('apiReportsCodeRunPost', 'code', code)
            // verify required parameter 'reportRunRequest' is not null or undefined
            assertParamExists('apiReportsCodeRunPost', 'reportRunRequest', reportRunRequest)
            const localVarPath = `/api/reports/{code}/run`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportRunRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportsApi - functional programming interface
 * @export
 */
export const ReportsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportCode} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsCodeGet(code: ReportCode, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsCodeGet(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsCodeGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportCode} code 
         * @param {ReportRunRequest} reportRunRequest 
         * @param {number} [organizationId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsCodeRunPost(code: ReportCode, reportRunRequest: ReportRunRequest, organizationId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportRunResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsCodeRunPost(code, reportRunRequest, organizationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsCodeRunPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ReportDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportsApi.apiReportsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportsApi - factory interface
 * @export
 */
export const ReportsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportsApiFp(configuration)
    return {
        /**
         * 
         * @summary Detail definice jednoho reportu
         * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportDefinitionResponse> {
            return localVarFp.apiReportsCodeGet(requestParameters.code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Spusti report a vrati data
         * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportRunResponse> {
            return localVarFp.apiReportsCodeRunPost(requestParameters.code, requestParameters.reportRunRequest, requestParameters.organizationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Seznam dostupnych reportu vcetne jejich parametru
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportDefinitionResponse>> {
            return localVarFp.apiReportsGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportsApi - interface
 * @export
 * @interface ReportsApi
 */
export interface ReportsApiInterface {
    /**
     * 
     * @summary Detail definice jednoho reportu
     * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportDefinitionResponse>;

    /**
     * 
     * @summary Spusti report a vrati data
     * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig): AxiosPromise<ReportRunResponse>;

    /**
     * 
     * @summary Seznam dostupnych reportu vcetne jejich parametru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApiInterface
     */
    apiReportsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ReportDefinitionResponse>>;

}

/**
 * Request parameters for apiReportsCodeGet operation in ReportsApi.
 * @export
 * @interface ReportsApiApiReportsCodeGetRequest
 */
export interface ReportsApiApiReportsCodeGetRequest {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportsApiApiReportsCodeGet
     */
    readonly code: ReportCode
}

/**
 * Request parameters for apiReportsCodeRunPost operation in ReportsApi.
 * @export
 * @interface ReportsApiApiReportsCodeRunPostRequest
 */
export interface ReportsApiApiReportsCodeRunPostRequest {
    /**
     * 
     * @type {ReportCode}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly code: ReportCode

    /**
     * 
     * @type {ReportRunRequest}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly reportRunRequest: ReportRunRequest

    /**
     * 
     * @type {number}
     * @memberof ReportsApiApiReportsCodeRunPost
     */
    readonly organizationId?: number
}

/**
 * ReportsApi - object-oriented interface
 * @export
 * @class ReportsApi
 * @extends {BaseAPI}
 */
export class ReportsApi extends BaseAPI implements ReportsApiInterface {
    /**
     * 
     * @summary Detail definice jednoho reportu
     * @param {ReportsApiApiReportsCodeGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsCodeGet(requestParameters: ReportsApiApiReportsCodeGetRequest, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsCodeGet(requestParameters.code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Spusti report a vrati data
     * @param {ReportsApiApiReportsCodeRunPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsCodeRunPost(requestParameters: ReportsApiApiReportsCodeRunPostRequest, options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsCodeRunPost(requestParameters.code, requestParameters.reportRunRequest, requestParameters.organizationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Seznam dostupnych reportu vcetne jejich parametru
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportsApi
     */
    public apiReportsGet(options?: RawAxiosRequestConfig) {
        return ReportsApiFp(this.configuration).apiReportsGet(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * WinningItemsApi - axios parameter creator
 * @export
 */
export const WinningItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Podíl vítězných položek za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWinningItemsGet: async (months?: number | null, organizationId?: number, portalId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/winning-items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (months !== undefined) {
                localVarQueryParameter['months'] = months;
            }

            if (organizationId !== undefined) {
                localVarQueryParameter['organizationId'] = organizationId;
            }

            if (portalId !== undefined) {
                localVarQueryParameter['portalId'] = portalId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WinningItemsApi - functional programming interface
 * @export
 */
export const WinningItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = WinningItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Podíl vítězných položek za posledních N měsíců
         * @param {number | null} [months] 
         * @param {number} [organizationId] 
         * @param {number} [portalId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiWinningItemsGet(months?: number | null, organizationId?: number, portalId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WinningItemsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiWinningItemsGet(months, organizationId, portalId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WinningItemsApi.apiWinningItemsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * WinningItemsApi - factory interface
 * @export
 */
export const WinningItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = WinningItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Podíl vítězných položek za posledních N měsíců
         * @param {WinningItemsApiApiWinningItemsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiWinningItemsGet(requestParameters: WinningItemsApiApiWinningItemsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<WinningItemsResponse> {
            return localVarFp.apiWinningItemsGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * WinningItemsApi - interface
 * @export
 * @interface WinningItemsApi
 */
export interface WinningItemsApiInterface {
    /**
     * 
     * @summary Podíl vítězných položek za posledních N měsíců
     * @param {WinningItemsApiApiWinningItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WinningItemsApiInterface
     */
    apiWinningItemsGet(requestParameters?: WinningItemsApiApiWinningItemsGetRequest, options?: RawAxiosRequestConfig): AxiosPromise<WinningItemsResponse>;

}

/**
 * Request parameters for apiWinningItemsGet operation in WinningItemsApi.
 * @export
 * @interface WinningItemsApiApiWinningItemsGetRequest
 */
export interface WinningItemsApiApiWinningItemsGetRequest {
    /**
     * 
     * @type {number}
     * @memberof WinningItemsApiApiWinningItemsGet
     */
    readonly months?: number | null

    /**
     * 
     * @type {number}
     * @memberof WinningItemsApiApiWinningItemsGet
     */
    readonly organizationId?: number

    /**
     * 
     * @type {number}
     * @memberof WinningItemsApiApiWinningItemsGet
     */
    readonly portalId?: number
}

/**
 * WinningItemsApi - object-oriented interface
 * @export
 * @class WinningItemsApi
 * @extends {BaseAPI}
 */
export class WinningItemsApi extends BaseAPI implements WinningItemsApiInterface {
    /**
     * 
     * @summary Podíl vítězných položek za posledních N měsíců
     * @param {WinningItemsApiApiWinningItemsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WinningItemsApi
     */
    public apiWinningItemsGet(requestParameters: WinningItemsApiApiWinningItemsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return WinningItemsApiFp(this.configuration).apiWinningItemsGet(requestParameters.months, requestParameters.organizationId, requestParameters.portalId, options).then((request) => request(this.axios, this.basePath));
    }
}



